import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type ArrowNarrowUpLeftIconProps = IconProps

const ArrowNarrowUpLeftIcon = forwardRef<
  SVGSVGElement,
  ArrowNarrowUpLeftIconProps
>((props: ArrowNarrowUpLeftIconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 18 6 6m0 0v8m0-8h8"
      fill="none"
    ></path>
  </Icon>
))

ArrowNarrowUpLeftIcon.displayName = 'ArrowNarrowUpLeftIcon'
ArrowNarrowUpLeftIcon.defaultProps = iconDefaultProps

export type { ArrowNarrowUpLeftIconProps }
export { ArrowNarrowUpLeftIcon }
